import {Component} from '@angular/core';
import {Help} from './help';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent {
  helps: Help[];

  constructor() {
    this.helps = [];
  }

  onFound(data: Help[]) {
    this.helps = data;
  }

}



// WEBPACK FOOTER //
// ./src/app/help/help.component.ts